<template>
  <el-card>
    <el-form class="" label-width="120px" label-position="right">
      <el-form-item label="服务名称：" prop="serviceName">
        {{ formData.serviceName }}
      </el-form-item>
      <el-form-item label="所属公园：" prop="projectName">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="服务类型：" prop="typeName">
        {{ formData.typeName }}
      </el-form-item>
      <el-form-item label="服务封面图：" prop="fileList">
        <custom-upload v-model="formData.fileList" disabled></custom-upload>
      </el-form-item>
      <el-form-item label="服务介绍：" prop="description">
        <div v-html="formData.description"></div>
      </el-form-item>
      <el-form-item label="服务位置：" prop="resourcesLocationList">
        <CustomMapMarker ref="map" :isClickPolyon="false" disabled :value=formData.resourcesLocationList>
        </CustomMapMarker>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { handleTLnglatList } from '@/utils/util'
export default {
  name: 'InparkserviceDetail',
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  data() {
    return {
      formData: {
        resourcesLocationList: []
      },
      polygonOverlays: [], // 用于存储多边形覆盖物的数组
    }
  },
  computed: {
    serviceId() {
      return this.$route.params.id
    },
    projectId() {
      return this.$route.query.projectId || ''
    }
  },
  created() {
    if (this.serviceId) {
      this.loadData()
    }
  },
  mounted() {
    this.mapRef = this.$refs.map
    this.projectId && this.drawPolyon(this.projectId)
  },
  methods: {
    // 围栏
    drawPolyon(projectId) {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: projectId
      }).then(res => {
        console.log(res, '建管')
        const parkInfo = res || {}
        // 绘制公园中心点
        // this.center = [{ longitude: parkInfo.longitude, latitude: parkInfo.latitude }]
        // 绘制电子围栏
        this.mapRef.setZoomAndCenter(18, [+parkInfo.longitude, +parkInfo.latitude])
        this.fenceList = handleTLnglatList(res.locationList || [])
        // 重新绘制前清除所有
        // 重新绘制前清除所有多边形覆盖物
        this.polygonOverlays.forEach(overlay => {
          overlay.setMap(null);
        });
        this.polygonOverlays = []; // 清空数组

        // 绘制多边形
        this.mapRef.drawPolyons(this.fenceList)
      }).finally(() => {
        this.loading = false
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectServiceFacilitiesByServiceId, {
        serviceId: this.serviceId
      }).then(res => {
        this.formData = res || {}
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
